import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

import '../../public/css/media/_modal-advisory.scss';

export default class AdvisoryModal extends Component {
  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.close} autoFocus={true} dialogClassName="custom-modal" style={{"zIndex": "99999"}}>
        <Modal.Header closeButton style={{"padding": "0"}}/>
        <div dangerouslySetInnerHTML={this.props.content} />
      </Modal>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AdvisoryModal.js
 **/